export const toISO = (d) => {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${dd}`;
};

export const fromISO = (s) => {
  const [y, m, dd] = s.split("-").map(Number);
  return new Date(y, m - 1, dd);
};

export const addDays = (d, n) => {
  const nd = new Date(d);
  nd.setDate(nd.getDate() + n);
  return nd;
};

export const formatDayLong = (d) =>
  d.toLocaleDateString("en-GB", { weekday: "long", day: "numeric", month: "long" });
export const formatDayShort = (d) =>
  d.toLocaleDateString("en-GB", { weekday: "short", day: "numeric", month: "short" });
export const prettyHost = (url) => {
  try {
    const u = new URL(url);
    return u.hostname.replace(/^www\./, "");
  } catch {
    return "link";
  }
};

export const computeTripBounds = (legs) => {
  if (!legs || legs.length === 0) {
    const today = new Date();
    return { start: today, end: today };
  }
  const sorted = [...legs].sort((a, b) => a.start.localeCompare(b.start));
  return { start: fromISO(sorted[0].start), end: fromISO(sorted[sorted.length - 1].end) };
};

export const computeAllDays = (start, end) => {
  const days = [];
  let d = new Date(start);
  while (d <= end) {
    days.push(new Date(d));
    d = addDays(d, 1);
  }
  return days;
};

export const makeLegForDate = (legs) => (date) => {
  const iso = typeof date === "string" ? date : toISO(date);
  return legs.find((l) => iso >= l.start && iso <= l.end);
};
